import React, { createContext, useContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const AUTHORIZED_STAFF_EMAILS = [
    'admin@holons.com.au',
    'info@holons.com.au',
    'giakaz@gmail.com',
    'linda_ksd@hotmail.com',
    'linda@holons.com.au',
    'giacomo@holons.com.au',
    'morokacafe@gmail.com'
  ];

  useEffect(() => {
    const savedUser = localStorage.getItem('puresouls_staff_user');
    if (savedUser) {
      try {
        const userData = JSON.parse(savedUser);
        if (AUTHORIZED_STAFF_EMAILS.includes(userData.email)) {
          setUser(userData);
        } else {
          localStorage.removeItem('puresouls_staff_user');
        }
      } catch (error) {
        localStorage.removeItem('puresouls_staff_user');
      }
    }
    setLoading(false);
  }, []);

  const login = (userData) => {
    if (AUTHORIZED_STAFF_EMAILS.includes(userData.email)) {
      setUser(userData);
      localStorage.setItem('puresouls_staff_user', JSON.stringify(userData));
      // Also store session_token separately for apiClient compatibility
      if (userData.session_token) {
        localStorage.setItem('sessionToken', userData.session_token);
      }
      return true;
    }
    return false;
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('puresouls_staff_user');
    if (window.google && window.google.accounts) {
      window.google.accounts.id.disableAutoSelect();
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, AUTHORIZED_STAFF_EMAILS }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
};
